// extracted by mini-css-extract-plugin
module.exports = {"modalSettings":"ParserSettings_modalSettings__3n4lO"};